import { z } from 'zod';
import { ButtonColors } from '@models/enums/components/Button/ButtonColor.enum';

// Enum schema
export const ButtonColorsSchema = z.nativeEnum(ButtonColors);

// Single button schemas
const LinkActionButtonSchema = z.object({
  text: z.string(),
  style: ButtonColorsSchema,
  buttonType: z.literal('url'),
  url: z.string().url(),
});

const ModalActionButtonSchema = z.object({
  text: z.string(),
  style: ButtonColorsSchema,
  buttonType: z.literal('modal'),
  modalText: z.string(),
});

// Discriminated union for a single button
export const ActionButtonSchema = z.discriminatedUnion('buttonType', [
  LinkActionButtonSchema,
  ModalActionButtonSchema,
]);

// Array of buttons
export const ActionButtonsSchema = z.array(ActionButtonSchema);
